import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';
import { RedirectGuard } from './guards/redirect.guard';

import { HttpRequestInterceptor } from './interceptors/httprequest.interceptor';

import { ListFilterPipe } from './pipes/list-filter.pipe';
import { ErrorFilterPipe } from './pipes/error-filter.pipe';
import { MakeTopFilterPipe } from './pipes/make-top-filter.pipe';
import { MaskEmailMobilePipe } from './pipes/mask-email-mobile.pipe';

import { HrefDirective } from './directives/href.directive';
import { MaskEmailDirective } from './directives/mask-email.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { MaskMobileDirective } from './directives/mask-mobile.directive';
import { AlphabetOnlyDirective } from './directives/alphabet-only.directive';

import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { AlertComponent } from './components/alert/alert.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgSelectModule
  ],
  declarations: [

    SpinnerComponent,
    ListFilterPipe,
    MakeTopFilterPipe,
    ErrorFilterPipe,
    HeaderComponent,
    FooterComponent,
    HrefDirective,
    AlphabetOnlyDirective,
    NumberOnlyDirective,
    MaskEmailDirective,
    MaskEmailMobilePipe,
    MaskMobileDirective,
    AlertComponent
  ],
  exports: [

    SpinnerComponent,
    ListFilterPipe,
    MakeTopFilterPipe,
    ErrorFilterPipe,
    HrefDirective,
    FooterComponent,
    HeaderComponent,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NumberOnlyDirective,
    AlphabetOnlyDirective,
    MaskEmailDirective,
    MaskEmailMobilePipe,
    MaskMobileDirective,
    AlertComponent
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    RedirectGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    }
  ]
})
export class SharedModule { }
